import { configureStore } from '@reduxjs/toolkit'
import cartReducer from '../redux/shopSlice'

export const store = configureStore({
    reducer: {
        cart: cartReducer,
    },
})